import React from 'react';

import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import parse from 'html-react-parser';
import GridContainer from "components/Grid/GridContainer.jsx";

const RSSParser = require('rss-parser');



function RssFeed({ feedURL, feedType }) {
    const [feed, setFeed] = React.useState();

    const CORS_PROXY = "https://cors-anywhere.herokuapp.com/"
    let parser = new RSSParser();
    parser.parseURL(CORS_PROXY + feedURL, function (err, feed) {
        if (err) throw err;
        setFeed(feed);
        
    })


    return (
        
        <GridContainer justify="center">
            { feed ? feed.items.map(i =>
                <GridItem xs={12} sm={12} md={12}>
                    <Card >
                        <CardHeader >
                            <h2>{i.title}</h2>
                        </CardHeader>

                        <CardBody>
                            {i.contentSnippet}
                            
                        </CardBody>
                        <CardFooter >
                        <Button href={i.link} color="primary" variant="contained">View article</Button>

                        </CardFooter>
                    </Card>
                </GridItem>
                
            ) : " loading"}
        </GridContainer>
        
    );

}

export default RssFeed

